// extracted by mini-css-extract-plugin
export default {"topBanner":"topBanner_topBanner__btrQR"};